

import React from 'react';
import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import Header from "../components/Header.jsx";
import { CreditCard } from "lucide-react";

const PaymentPosterPage = () => {
  const { user, logout, loading: authLoading } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  if (authLoading) return <div className="text-center p-8">Loading authentication...</div>;
  if (!user) return <div className="text-center p-8">Redirecting to login...</div>;

  const navItems = [
    { label: "Dashboard", icon: <CreditCard className="w-4 h-4" />, mode: "dashboard" },
  ];

  return (
    <>
      <Header
        user={user}
        onLogout={handleLogout}
        navItems={navItems}
        currentViewMode="dashboard"
        onViewModeChange={() => {}}
        overdueTaskCount={0}
      />
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 font-sans">
        <div className="w-full px-4 sm:px-6 lg:px-8 py-8">
          <div className="bg-white rounded-xl  border border-gray-200 overflow-hidden p-8">
            <h1 className="text-3xl font-bold text-gray-800 mb-6 border-b pb-4">
              Payment Poster Dashboard
            </h1>

            {user && (
              <div className="space-y-4">
                <p className="text-lg text-gray-700">
                  <span className="font-semibold">Welcome,</span> {user.username}
                </p>
                <p className="text-gray-600">
                  <span className="font-semibold">User ID:</span> {user.userId}
                </p>
                <p className="text-gray-600 capitalize">
                  <span className="font-semibold">Role:</span> {user.role}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentPosterPage;